// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ScritturaElisioneRigaDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ScritturaElisioneRigaApiClient extends BaseCRUDApiClient<ScritturaElisioneRigaDto> {
  baseUrl = this.config.apiEndpoint + '/scrittura-elisione-riga';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
